<template>
  <div>
    <div id="article-video">
      <h1 class="title">{{title}}</h1>
      <div class="article-time">{{time}}</div>
      <div class="video" v-html="content"></div>
    </div>
    
    <div class="trend-wrap">
      <h2>精选动态</h2>
      <div class="project-list">
        <div class="project-item" :class="{'border-right': i !== newsTrendsList.length-1 && (i+1)%3 !==0}" v-for="(v, i) in newsTrendsList" :key="i" @click="goArtcle(v)">
          <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/newimg.png')">
          <div class="project-title txt-line-1 hidden-xs-only">{{v.title}}</div>
          <div class="project-title-xs txt-line-3">{{v.title}}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import {reContent, imgError} from '@/assets/utility'
import {getEliteArticleList} from '@/api/news'

export default {
  // components: { Crumbs },
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      content: '',
      crumbsList: [],
      title: '',
      time: '',
      newsTrendsList: []
    }
  },
  mounted() {
    this.$axios.post(`currency/getArticleById?id=${this.$route.params.aid}`).then((res)=>{
      if (res) {
        this.title = res.title
        this.time = res.createTime
        this.content = reContent(res.content)
        this.crumbsList = res.columns.reverse()
      }
    })
    getEliteArticleList().then(res => {
      if (res) {
        this.newsTrendsList = res
      }
    })
  },
  methods: {
    imgError(pUrl) {
      imgError(pUrl)
    },
    goArtcle(pData) {
      this.$router.push(`/article/${pData.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>

  .new-trends {
    background-color: #fff;
    h2 {
      margin: 0;
      text-align: center;
      font-weight: 400;
      color: #333333;
    }
    .new-trends-list {
      display: flex;
      flex-wrap: wrap;
      .new-trends-item {
        position: relative;
        cursor: pointer;
        .new-trends-img {
          position: relative;
          .title {
            position: absolute;
            bottom: 0;
            display: block;
            box-sizing: border-box;
            width: 100%;
            text-align: center;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
    }
  }
  .trend-wrap {
    padding: rem(50) rem(75);
  }
  @media only screen and (min-width: 768px) {
    .project-list {
      justify-content: start;
    }
    #article-video {
      //margin:  0 rem(225);
      //margin-bottom: rem(50);
      padding: rem(50) rem(80);
      ///background-color: #f9f9f9;
      background-color: #fff;
      video {
        width: 100%!important;
      }
      .title {
        font-size: rem(24); 
        font-weight: 500;
        color: #282828;
      }
      .article-time {
        font-size: rem(20);
        font-weight: 400;
        color: #808080;
      }
    }
    .new-trends {
      margin: 0 rem(225);
      padding: rem(30) rem(50);
      h2 {
        font-size: rem(36);
      }
      .new-trends-list {
        padding: rem(50);
        .new-trends-item {
          margin-right: rem(40);
          margin-bottom: rem(40);
          width: rem(397);
          .new-trends-img {
            height: rem(207);
            .bg-img {
              border-radius: rem(48);
            }
            .title {
              padding: rem(20) rem(41);
              font-size: rem(21);
              line-height: rem(34);
            }
          }
          .title {
            display: none;
          }
        }
        .new-trends-item:nth-child(3n){
          margin-right: 0;
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    #article-video {
      margin:  0 .575rem;
      padding: .5rem 0;
      .title {
        font-size: .30rem;
        font-weight: 400;
        color: #282828;
      }
      .article-time {
        font-size: .24rem;
        font-weight: 400;
        color: #808080;
      }
    }
    
    .new-trends {
      padding: .3rem .57rem;
      h2 {
        font-size: 0.48rem;
      }
      .new-trends-list {
        padding-top: .5rem;
        .new-trends-item {
          margin-right: .31rem;
          margin-bottom: .31rem;
          width: 3.02rem;
          .new-trends-img {
            height: 1.6rem;
            .bg-img {
              border-radius: .25rem;
            }
          }
          .title {
            padding: .25rem 0;
            font-size: 0.3rem;
            font-weight: 500;
            color: #333333;
            line-height: 0.4rem;
          }
        }
        .new-trends-item:nth-child(2n){
          margin-right: 0;
        }

      }
    }
  }
</style>
